import(/* webpackMode: "eager" */ "/app/src/app/[locale]/contact/page.tsx");
